

import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'web-library';
import RouteKey from '../../../../routes/key';
import { UpdateResitCandidateSelectedSubjects } from '../../../../store/resitSlice';
import { useAppealNavigation } from '../../../../routes/AppealRoute';
import ReceiptDetail from "./receipt/ReceiptDetail";
import { parseLocationSearch } from '../../../../utils/StringUtils';
import { useWOGAA } from '../../../../hooks/wogaa';

import { candidateService } from '../../../../api';

const { appeal } = RouteKey.child;
const { applications } = RouteKey.appeal.child;

const useStyles = makeStyles()((theme) =>
({
  title: {
    marginBottom: theme.spacing(2),
  },
  submitForm: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  iconButton: {
    padding: theme.spacing(1),
    margin: 0,
    marginLeft: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
}));

interface ResitReceiptPathParams {
  internalTransactionRef?: string;
}

const AppealReceipt = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { toSummary: appealToSummary } = useAppealNavigation();

  const [toSummaryPath, setToSummaryPath] = useState(appealToSummary);

  useEffect(() => {
    if (appealToSummary) {
      setToSummaryPath(appealToSummary);
    }
  }, [appealToSummary]);

  const location = useLocation<ResitReceiptPathParams>();
  const { internalTransactionRef } = parseLocationSearch(location.search);
  const { transactionEnd } =  useWOGAA('myexamsseab-6473');

  /** WOGAA complete transaction for appeal flow
   * */
  transactionEnd(internalTransactionRef);

  /** to get resit payment transaction
   * */
  const { data } = candidateService.appeal.candidate.useGetAppealReceipt(
    internalTransactionRef
  );

  useEffect(() => {
    dispatch(UpdateResitCandidateSelectedSubjects([]));
  }, [dispatch]);
  return (
    <>
      <ReceiptDetail
        transaction={{
          transactionNumber: data?.transactionNumber || '',
          internalTransactionRef: data?.internalTransactionRef,
          totalFee: data?.totalFee || '0',
          paymentMethod: data?.paymentMethod || '',
          paymentTimeStamp: data?.paymentTimeStamp || '',
          gstRegNo: data?.gstRegNo,
        }}
        toSummary={() => {
          history.push(`${toSummaryPath}?uuid=${data?.registrationUuid}`)
        }}
      />

      <Button
        id="button-resitReceipt-goToRegisteredExams"
        className={classes.button}
        onClick={() => history.push(`/${appeal}/${applications.route}`)}
      >
        {t('appeal->>AppealReceipt.BackToAppealApplications')}
      </Button>
    </>
  );
};

export default AppealReceipt;
